import React from 'react';

// Helper functions (can be moved to utils later if reused)
const getInitials = (name) => {
  if (!name) return '?';
  const initials = name.match(/\b\w/g) || [];
  return ((initials.shift() || '') + (initials.pop() || '')).toUpperCase();
};

const generateColor = (username) => {
  if (!username) return 'bg-gray-400';
  let hash = 0;
  for (let i = 0; i < username.length; i++) {
    hash = username.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colors = [
    'bg-red-500', 'bg-orange-500', 'bg-yellow-500', 'bg-green-500', 
    'bg-teal-500', 'bg-blue-500', 'bg-indigo-500', 'bg-purple-500', 'bg-pink-500'
  ];
  return colors[Math.abs(hash) % colors.length];
};

const AddressDisplay = ({ title, name, address, company, phone, email }) => (
  <div>
    <h3 className="text-lg font-medium text-gray-600 mb-3">{title}</h3>
    {address ? (
      <address className="mt-1 not-italic text-sm text-gray-600">
        {name && <>{name}<br /></>}
        {company && <>{company}<br /></>}
        {address.street1 || ''}<br />
        {address.street2 ? <>{address.street2}<br /></> : ''}
        {address.city || ''}, {address.state || ''} {address.postalCode || ''}<br />
        {address.country || ''}
        {phone && <><br />{phone}</>}
        {email && <><br />{email}</>}
      </address>
    ) : (
      <p className="text-sm text-red-500">Address information missing.</p>
    )}
  </div>
);

const CustomerDisplay = ({ customer, shippingAddress }) => {
  const customerName = customer?.username || 'Customer';
  const customerProfilePic = customer?.profilePic?.formats?.thumbnail?.url || customer?.profilePic?.url;
  const customerInitials = getInitials(customerName);
  const avatarColor = generateColor(customerName);

  return (
    <div>
      <h3 className="text-lg font-medium text-gray-600 mb-3">Customer & Destination</h3>
      <div className="flex items-center space-x-3">
        {customerProfilePic ? (
          <img 
            src={customerProfilePic}
            alt={customerName}
            className="w-10 h-10 rounded-full object-cover flex-shrink-0"
          />
        ) : (
          <div 
            className={`w-10 h-10 rounded-full flex items-center justify-center bg-brand-teal text-white font-medium text-sm flex-shrink-0`}
          >
            {customerInitials}
          </div>
        )}
        <div>
          <p className="text-sm text-gray-600">{customerName}</p>
          {shippingAddress ? (
            <p className="text-sm text-gray-600 mt-0.5">
              {shippingAddress.city && `${shippingAddress.city}, `}
              {shippingAddress.country && `${shippingAddress.country}`}
              {shippingAddress.postalCode && ` ${shippingAddress.postalCode}`}
            </p>
          ) : (
             <p className="text-xs text-red-500 mt-1">Destination address missing.</p>
          )}
        </div>
      </div>
    </div>
  );
};

const ShipmentSummary = ({ customer, customerShippingAddress, merchantOriginAddress }) => {
  return (
    <div className="grid md:grid-cols-2 gap-6 mb-6">
      <CustomerDisplay customer={customer} shippingAddress={customerShippingAddress} />
      <AddressDisplay 
        title="Merchant Origin Address"
        name={merchantOriginAddress?.name}
        company={merchantOriginAddress?.company}
        address={merchantOriginAddress} // Pass the whole address object
        phone={merchantOriginAddress?.phone}
        email={merchantOriginAddress?.email}
      />
    </div>
  );
};

export default ShipmentSummary; 